export const PRIMARY = 'primary'
export const SECONDARY = 'secondary'
export const TRANSPARENT = 'transparent'
export const BLUE = 'blue'
export const CYAN = 'cyan'
export type TzAddressStyles =
  | typeof PRIMARY
  | typeof SECONDARY
  | typeof CYAN
  | typeof TRANSPARENT
  | typeof BLUE
  | undefined
